import { arrivalTimes } from './arrivalTimes';
import { baseSpaDay } from './baseSpaDay';
import { extras } from './extras';
import { inclusionsWithoutTimes } from './inclusions';

// Spa Package with arrival times, no time slot support and no choices
export const scenario1 = {
  ...baseSpaDay,
  ...arrivalTimes,
  configurationGroupsRequireTimeslots: false,
  configurationGroupsSupportTimeslots: false,
  configurationGroups: [...inclusionsWithoutTimes, ...extras],
};
